<template>
      <div class="nt-checkbox-list">
          <slot></slot>
      </div>

</template>

<script>

export default {
    name:'nt-checkbox-list',
    props:{
        value:Array
    }
}
</script>

<style>

</style>
